import {Component, Input, ViewChild} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import {AzureApiService} from "../services/azure-api.service";
import {ScreenService} from "../../fw/services/screen.service";
import {ReportParam} from "./models/ReportParam";
import nlMessagesDxReporting from '../../localization/nl/dx-reporting.nl.json';
import nlMessagesDxAnalyticsCore from '../../localization/nl/dx-analytics-core.nl.json';
import {DxReportViewerComponent} from "devexpress-reporting-angular";

@Component({
    selector: 'report-preview',
    template: require('./report-preview.component.html'),
    styles: [require('./report-preview.component.css')]
})

export class ReportPreviewComponent  {
    @Input() dialog: DialogRef;
    @Input() reportParams: ReportParam[];
    @Input() reportName: string;
    @Input() useDevExpress: boolean;
    @ViewChild('reportViewer', {static: false})reportViewer: DxReportViewerComponent;
    url: string;
    token: string;
    devExpressUrl: string = 'https://app-mijnsalonng-reportapi-prod.azurewebsites.net/';
    reportUrl: string;
    currentDocumentId: string;
    invokeAction: string = 'DXXRDV';



    constructor(private http: AzureApiService,
                private ss: ScreenService) {
    }

    ngOnInit() {
        this.reportUrl = `${this.reportName}?${this.buildParameterString(this.reportParams)}`;
    }

    btnClicked(event) {
        this.closeWindow();
    }

    closeWindow() {
        if (this.dialog) {
            this.dialog.close();
        }
    }

    CustomizeLocalization(event) {
        event.args.LoadMessages(nlMessagesDxAnalyticsCore);
        event.args.LoadMessages(nlMessagesDxReporting);
    }

    CustomizeMenuActions(event) {
        let toolbarPart = event.args.GetById('dxxrp-highlight-editing-fields');
        if (toolbarPart) {
            toolbarPart.visible = false;
        }
        let toolbarPart2 = event.args.GetById('dxxrp-search');
        if (toolbarPart2) {
            toolbarPart2.visible = false;
        }
    }

    DocumentReady($event: any) {
        this.currentDocumentId = $event.args.DocumentId;
    }

    private buildParameterString(reportParams: ReportParam[]): string {
        let parameters: string = `DatabaseName=${sessionStorage.getItem('database')}`;
        parameters += `&ApplicationMode=1`;
        parameters += `&userId=${sessionStorage.getItem('userId')}`;
        parameters += `&DatabaseServer=${sessionStorage.getItem('server')}`;
        parameters += `&DatabaseMasterUserId=${sessionStorage.getItem('userId')}`;

        if (reportParams) {
            for (let param of reportParams) {
                if (param.value) {
                    if (parameters.length > 1) parameters = parameters + '&';
                    parameters += `${param.name}=${param.value}`;
                }
            }
        }

        return parameters;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/report-preview.component.ts